const UsedCell = ({ voucher }) => (
    <p className="mb-0 text-muted">
        <span className="fw-semibold text-dark">{voucher.used_count}</span> / <span className="fw-semibold text-dark">{voucher.quota}</span>
    </p>
)

export default UsedCell